let GLOBAL_CONFIG = {};

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    GLOBAL_CONFIG = {
        survey_url: "https://survey.typeform.com/to/npo9eCrQ",
        firebase_config: {
            apiKey: "AIzaSyD5AiowWqvD7IL9c7cuGvkzKvXRhuVGlpQ",
            authDomain: "d-ai-365820.firebaseapp.com",
            projectId: "d-ai-365820",
            storageBucket: "3d-ai-user-assets-staging",
            messagingSenderId: "473268446896",
            appId: "1:473268446896:web:8d156a4aeeeccb984ffd75",
            databaseURL: "https://d-ai-rtdb-staging.firebaseio.com"
        },
        sd_root_url: "https://api-staging-7qtp55otdq-uw.a.run.app/generate_sd_root",
        sd_child_url: "https://api-staging-7qtp55otdq-uw.a.run.app/generate_sd_child",
        prompt_boost_url: "https://api-staging-7qtp55otdq-uw.a.run.app/generate_text",
        save_as_asset_url: "https://api-staging-7qtp55otdq-uw.a.run.app/save_asset/",
        remove_asset_url: "https://api-staging-7qtp55otdq-uw.a.run.app/remove_asset/",
        upload_url: "https://api-staging-7qtp55otdq-uw.a.run.app/asset/",
        add_default_assets_url: "https://api-staging-7qtp55otdq-uw.a.run.app/add_default_assets",
        outputs_bucket_path: "gs://ml-outputs-staging",
        default_assets_bucket_path: "gs://default-image-assets",
        default_3d_assets_bucket_path: "gs://default-3d-assets",
        texturing_3d_url: "https://api-staging-7qtp55otdq-uw.a.run.app/generate_texturing",
        texturing_3d_volumetric_url: "https://api-staging-7qtp55otdq-uw.a.run.app/generate_volumetric"
    };
} else {
    GLOBAL_CONFIG = {
        survey_url: "https://survey.typeform.com/to/npo9eCrQ",
        firebase_config: {
            apiKey: "AIzaSyD5AiowWqvD7IL9c7cuGvkzKvXRhuVGlpQ",
            authDomain: "d-ai-365820.firebaseapp.com",
            projectId: "d-ai-365820",
            storageBucket: "3d-ai-user-assets-staging",
            messagingSenderId: "473268446896",
            appId: "1:473268446896:web:8d156a4aeeeccb984ffd75",
            databaseURL: "https://d-ai-rtdb-staging.firebaseio.com"
        },
        sd_root_url: "https://api-7qtp55otdq-uw.a.run.app/generate_sd_root",
        sd_child_url: "https://api-7qtp55otdq-uw.a.run.app/generate_sd_child",
        prompt_boost_url: "https://api-7qtp55otdq-uw.a.run.app/generate_text",
        save_as_asset_url: "https://api-7qtp55otdq-uw.a.run.app/save_asset/",
        remove_asset_url: "https://api-7qtp55otdq-uw.a.run.app/remove_asset/",
        upload_url: "https://api-7qtp55otdq-uw.a.run.app/asset/",
        add_default_assets_url: "https://api-7qtp55otdq-uw.a.run.app/add_default_assets",
        outputs_bucket_path: "gs://ml-outputs-staging",
        default_assets_bucket_path: "gs://default-image-assets",
        default_3d_assets_bucket_path: "gs://default-3d-assets",
        texturing_3d_url: "https://api-7qtp55otdq-uw.a.run.app/generate_texturing",
        texturing_3d_volumetric_url: "https://api-7qtp55otdq-uw.a.run.app/generate_volumetric",
    };
}

export {
    GLOBAL_CONFIG
};